import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import { BLUE_GRADIENT_CSS } from "@/challenges/constants/styles.constants";
import challengesRowBackground from "./challengesRowBackground.png";
import challengesRowBackgroundLarge from "./challengesRowBackgroundLarge.png";
import challengesRowBackgroundSmall from "./challengesRowBackgroundSmall.png";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, sm, md },
} = constants.breakpoints;

const black = constants.colors.status.neutral[700];

export const challengeWrapper = (isHomeVersion: boolean): CSSObject => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  width: "100%",
  color: black,
  ...BLUE_GRADIENT_CSS,
  background: isHomeVersion
    ? `url(${challengesRowBackgroundSmall.src}) no-repeat`
    : "transparent",
  backgroundAttachment: "initial",
  backgroundPosition: "center top",

  [mq.downTo(xs)]: {
    padding: "0px 1em 31px 1em",
    background: isHomeVersion
      ? `url(${challengesRowBackground.src}) no-repeat`
      : "transparent",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },

  [mq.downTo(sm)]: {
    padding: "0px 2.5em 31px 2.5em",
  },

  [mq.downTo(md)]: {
    padding: "0px 5em 31px 5em",
    background: isHomeVersion
      ? `url(${challengesRowBackgroundLarge.src}) no-repeat`
      : "transparent",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
});

export const loadingWrapper: CSSObject = {
  height: "82vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
